const route = {
  routeCode: '路线代码',
  shipDcNo: '发货DC编码',
  carrierNo: '运输商编码',
  transitTime: '在途时间',
  receiptReturnTime: '回单返回时间',
  msg: {}
};
export default route;



// WEBPACK FOOTER //
// ./src/page/md/route/lang/route.zh.js